/**
 * W-FAQ Component
 * Handles tabs navigation and accordion functionality
 */

class WFaq {
  constructor(section) {
    this.section = section;
    this.tabButtons = this.section.querySelectorAll('.section-faq__tab-button');
    this.tabPanels = this.section.querySelectorAll('.section-faq__tab-panel');
    this.accordionHeaders = this.section.querySelectorAll('.section-faq__accordion-header');

    this.init();
  }

  init() {
    this.setupTabs();
    this.setupAccordion();
    this.initializeOpenItems();
  }

  /**
   * Initialize accordion items that are open by default
   */
  initializeOpenItems() {
    const openItems = this.section.querySelectorAll('.section-faq__accordion-item--open');
    openItems.forEach((item) => {
      const content = item.querySelector('.section-faq__accordion-content');
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }

  /**
   * Setup tabs navigation
   */
  setupTabs() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const tabIndex = button.getAttribute('data-tab-index');
        this.switchTab(tabIndex);
      });
    });
  }

  /**
   * Switch active tab
   */
  switchTab(index) {
    // Remove active class from all buttons and panels
    this.tabButtons.forEach((btn) => {
      btn.classList.remove('section-faq__tab-button--active');
    });

    this.tabPanels.forEach((panel) => {
      panel.classList.remove('section-faq__tab-panel--active');
    });

    // Add active class to selected button and panel
    const selectedButton = this.section.querySelector(
      `[data-tab-index="${index}"]`
    );
    const selectedPanel = this.section.querySelector(
      `[data-tab-panel="${index}"]`
    );

    if (selectedButton) {
      selectedButton.classList.add('section-faq__tab-button--active');
    }

    if (selectedPanel) {
      selectedPanel.classList.add('section-faq__tab-panel--active');
    }
  }

  /**
   * Setup accordion functionality
   */
  setupAccordion() {
    this.accordionHeaders.forEach((header) => {
      header.addEventListener('click', (e) => {
        const accordionItem = header.closest('.section-faq__accordion-item');
        const content = accordionItem.querySelector('.section-faq__accordion-content');

        if (!accordionItem || !content) return;

        // Toggle the accordion item
        const isOpen = accordionItem.classList.contains('section-faq__accordion-item--open');

        if (isOpen) {
          this.closeAccordionItem(accordionItem, content);
        } else {
          this.openAccordionItem(accordionItem, content);
        }
      });
    });
  }

  /**
   * Open accordion item
   */
  openAccordionItem(item, content) {
    item.classList.add('section-faq__accordion-item--open');
    content.style.maxHeight = content.scrollHeight + 'px';
  }

  /**
   * Close accordion item
   */
  closeAccordionItem(item, content) {
    item.classList.remove('section-faq__accordion-item--open');
    content.style.maxHeight = '0';
  }

  /**
   * Destroy event listeners
   */
  destroy() {
    this.tabButtons.forEach((button) => {
      button.replaceWith(button.cloneNode(true));
    });

    this.accordionHeaders.forEach((header) => {
      header.replaceWith(header.cloneNode(true));
    });
  }
}

// Initialize FAQ sections
document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('[data-section-type="w-faq"]');

  faqSections.forEach((section) => {
    new WFaq(section);
  });
});

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-faq"]');
    if (section) {
      new WFaq(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-section-type="w-faq"]');
    if (section && section.wFaqInstance) {
      section.wFaqInstance.destroy();
    }
  });
}

// Expose class globally for dynamic initialization
window.WFaq = WFaq;
